const endPoint = process.env.REACT_APP_BASE_END_POINT;
const autopsEndpoint = process.env.REACT_APP_AUTOPS_END_POINT;
export const UrlHelpers = {
  createDomain: `${endPoint}/app/template-engine/v2/create-domain`,
  getTemplateMetaData: `${endPoint}/app/template-engine/v2/get-template-metadata`,
  getTemplateList: `${endPoint}/app/template-engine/v2/get-template-list`,
  fetchPresignedurl: `${endPoint}/app/template-engine/v2/fetch-presigned-url`,
  manageTemplate: `${endPoint}/app/template-engine/v2/create-template-json`,
  uploadcsv: `${endPoint}/dnotificationapi/v2/upload`,
  uploadcsvxl: `${endPoint}/dnotificationapi/v2/uploadxl`,
  autogeneratePassword: (username) =>
    `${endPoint}/ob-idmapi/admin/users/autogenerate-pwd/${encodeURIComponent(username)}`,
  updateUser: (username) =>
    `${endPoint}/ob-idmapi/admin/users/suspend/${encodeURIComponent(username)}`,
  authInitiateui: `${endPoint}/dnotificationapi/authenticated/initiateui`,
  userSearch: (queryString = '') =>
    `${endPoint}/ob-idmapi/admin-portal-utility/users/search${
      queryString ? `?${queryString}` : ''
    }`,
  userDetails: (queryString = '') =>
    `${endPoint}/ob-idmapi/admin-portal-utility/users/details${
      queryString ? `?${queryString}` : ''
    }`,
  userAudit: (queryString = '') =>
    `${endPoint}/ob-idmapi/admin-portal-utility/users/audit${queryString ? `?${queryString}` : ''}`,
  getAutopsAlert: `${autopsEndpoint}/autops/alerts`,
  autopsCreateAlert: `${autopsEndpoint}/autops/alerts`,
  autopsAlertDetails: (id) => `${autopsEndpoint}/autops/alerts/${id}`,
  autopsInvestigateAlert: (id) => `${autopsEndpoint}/autops/alerts/${id}/investigate`,
  autopsReviewAlert: (id) => `${autopsEndpoint}/autops/alerts/${id}/review`,
  autopsRejectAlert: (id) => `${autopsEndpoint}/autops/alerts/${id}/reject`,
  autopsKbDraft: (alarmName) => `${autopsEndpoint}/autops/kb-drafts/${alarmName}`,
  autopsKbDraftApprove: (alarmName) => `${autopsEndpoint}/autops/kb-drafts/${alarmName}/approve`,
  autopsKbDraftReject: (alarmName) => `${autopsEndpoint}/autops/kb-drafts/${alarmName}/reject`,
};
